// test1265
(1265 && 0);
